module.exports = {"errorRequired":"This field is required.","errorInvalid":"The format is invalid.","msg":{"error":"An error has occured."}}


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/locales/en.json
// module id = 1365
// module chunks = 0